
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/public-app/athlete/view_competitor_data.css.ts.vanilla.css\",\"source\":\"Ll8xeHByb3liMCB7CiAgd2lkdGg6IDIyMHB4OwogIHBhZGRpbmc6IDAgMCAwIDIwcHg7CiAgZmxleDogMCAwIDIyMHB4Owp9Ci5fMXhwcm95YjEgewogIHdpZHRoOiAxNDBweDsKICBwYWRkaW5nOiAwIDAgMCAyMHB4OwogIGZsZXg6IDAgMCAxNDBweDsKfQouXzF4cHJveWIyIHsKICB3aWR0aDogMTYwcHg7CiAgcGFkZGluZzogMCAwIDAgMjBweDsKICBmbGV4OiAwIDAgMTYwcHg7Cn0KLl8xeHByb3liNSB7CiAgYm9yZGVyLXRvcDogMXB4IHNvbGlkIHZhcigtLV8xajdycDU3MXQpOwogIHBhZGRpbmc6IDEwcHg7Cn0=\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/public-app/athlete/view_competitor_data.css.ts.vanilla.css\",\"source\":\"Ll8xeHByb3liMCB7CiAgd2lkdGg6IDIyMHB4OwogIHBhZGRpbmc6IDAgMCAwIDIwcHg7CiAgZmxleDogMCAwIDIyMHB4Owp9Ci5fMXhwcm95YjEgewogIHdpZHRoOiAxNDBweDsKICBwYWRkaW5nOiAwIDAgMCAyMHB4OwogIGZsZXg6IDAgMCAxNDBweDsKfQouXzF4cHJveWIyIHsKICB3aWR0aDogMTYwcHg7CiAgcGFkZGluZzogMCAwIDAgMjBweDsKICBmbGV4OiAwIDAgMTYwcHg7Cn0KLl8xeHByb3liNSB7CiAgYm9yZGVyLXRvcDogMXB4IHNvbGlkIHZhcigtLV8xajdycDU3MXQpOwogIHBhZGRpbmc6IDEwcHg7Cn0=\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
